export default homePage => {
    // console.log('homePage');

    const heroMiddleContent = homePage.querySelector('.hero-middle-content');
    const point = homePage.querySelector('.point');
    const reveals = document.querySelectorAll('.reveal');
    // const cursor = document.querySelector('#cursor');

    // function cursorPosition(event) {
    //     const x = event.clientX - 15;
    //     const y = event.clientY - 15;

    //     cursor.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    // }

    // function cursorDown(event) {
    //     const x = event.clientX - 20;
    //     const y = event.clientY - 20;

    //     cursor.classList.add('down');
    //     cursor.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    // }

    // function cursorUp() {
    //     cursor.classList.remove('down');
    // }

    function pointPosition(event) {
        point.style.top = `${event.layerY - 125}px`;
        point.style.right = 'auto';
        point.style.left = `${event.layerX - 125}px`;
    }

    function resetPointPosition() {
        point.style.top = '-56px';
        point.style.right = '-79px';
        point.style.left = 'auto';
    }

    function callback(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => {
                    entry.target.classList.add('show');
                }, 100);
            }
        });
    }

    reveals.forEach(element => {
        new IntersectionObserver(callback, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        }).observe(element);
    });

    if (window.innerWidth >= 1440) {
        heroMiddleContent.addEventListener('mousemove', pointPosition);
        heroMiddleContent.addEventListener('mouseleave', resetPointPosition);
        // document.addEventListener('mousemove', cursorPosition);
        // document.addEventListener('mousedown', cursorDown);
        // document.addEventListener('mouseup', cursorUp);
    }
};
